import { render, staticRenderFns } from "./AssignTeamToProject.vue?vue&type=template&id=0940f6c4&scoped=true"
import script from "./AssignTeamToProject.vue?vue&type=script&lang=js"
export * from "./AssignTeamToProject.vue?vue&type=script&lang=js"
import style0 from "./AssignTeamToProject.vue?vue&type=style&index=0&id=0940f6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940f6c4",
  null
  
)

export default component.exports